import { IPassionDetailsAtAGlanceResponse, IPassionDetailsConveningsResponse, IPassionDetailsMapSnippetResponse, IPassionDetailsPeopleDrawerParams, IPassionDetailsPeopleDrawerResponse, IPassionDetailsResponse, IPassionDetailsSimilarPassionsResponse } from "app/components/DetailsPages/interfaces/passion"
import { http } from "./http"

export const getPassionDetails = (slug: string) => {
  return http.get<IPassionDetailsResponse>(`passion/${slug}/details`)
}

export const getPassionAtAGlance = (slug: string) => {
  return http.get<IPassionDetailsAtAGlanceResponse>(`passion/${slug}/details/at_a_glance`);
}

export const getPassionMapSnippet = (slug: string) => {
  return http.get<IPassionDetailsMapSnippetResponse>(`passion/${slug}/details/map_snippet`);
}

export const getSimiliarPassions = (slug: string) => {
  return http.get<IPassionDetailsSimilarPassionsResponse>(`passion/${slug}/details/similar_passions`);
}

export const getPassionConvenings = (slug: string) => {
  return http.get<IPassionDetailsConveningsResponse>(`passion/${slug}/details/convenings`);
}

export const getPassionPeopleDrawer = (slug: string, params?: IPassionDetailsPeopleDrawerParams) => {
  return http.get<IPassionDetailsPeopleDrawerResponse>(`passion/${slug}/drawers/people`, params); 
}
